/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */
import { Vector3, Vector4 } from '@canvas/vector';

export const none = new Vector3(0, 0, 0);
export const white = new Vector3(255, 255, 255);

export const b100 = new Vector3(233, 242, 255);
export const b200 = new Vector3(204, 224, 255);
export const b300 = new Vector3(133, 184, 255);
export const b600 = new Vector3(29, 122, 252);
export const b700 = new Vector3(12, 102, 228);
export const b800 = new Vector3(0, 85, 204);
export const g100 = new Vector3(223, 252, 240);
export const g150 = new Vector3(199, 248, 227);
export const g300 = new Vector3(118, 224, 180);
export const g600 = new Vector3(34, 160, 107);
export const g700 = new Vector3(31, 132, 90);
export const g800 = new Vector3(33, 110, 78);
export const l100 = new Vector3(239, 255, 214);
export const l200 = new Vector3(211, 241, 167);
export const l300 = new Vector3(179, 233, 114);
export const l600 = new Vector3(106, 154, 35);
export const l700 = new Vector3(91, 127, 36);
export const l800 = new Vector3(76, 107, 31);
export const m100 = new Vector3(255, 236, 248);
export const m200 = new Vector3(253, 208, 236);
export const m300 = new Vector3(247, 151, 210);
export const m600 = new Vector3(205, 81, 157);
export const m700 = new Vector3(174, 71, 135);
export const m800 = new Vector3(148, 61, 115);
export const n0 = white;
export const n100 = new Vector3(247, 248, 249);
export const n200 = new Vector3(241, 242, 244);
export const n30 = new Vector3(241, 242, 244);
export const n300 = new Vector3(220, 223, 228);
export const n400 = new Vector3(179, 185, 196);
export const n50 = new Vector3(193, 199, 208);
export const n600 = new Vector3(117, 129, 149);
export const n700 = new Vector3(98, 111, 134);
export const n800 = new Vector3(68, 84, 111);
export const o100 = new Vector3(255, 245, 235);
export const o300 = new Vector3(254, 193, 118);
export const o600 = new Vector3(219, 110, 0);
export const o700 = new Vector3(194, 81, 0);
export const o800 = new Vector3(151, 79, 12);
export const orange = new Vector3(255, 222, 184);
export const p100 = new Vector3(243, 240, 255);
export const p200 = new Vector3(223, 216, 253);
export const p300 = new Vector3(184, 172, 246);
export const p600 = new Vector3(130, 112, 219);
export const p700 = new Vector3(110, 93, 198);
export const p800 = new Vector3(94, 77, 178);
export const r100 = new Vector3(255, 237, 235);
export const r300 = new Vector3(255, 154, 143);
export const r600 = new Vector3(232, 66, 44);
export const r700 = new Vector3(201, 55, 44);
export const r800 = new Vector3(174, 42, 25);
export const red = new Vector3(255, 210, 204);
export const t100 = new Vector3(227, 250, 252);
export const t300 = new Vector3(116, 219, 231);
export const t600 = new Vector3(29, 154, 170);
export const t700 = new Vector3(34, 125, 155);
export const t800 = new Vector3(32, 107, 116);
export const teal = new Vector3(200, 244, 249);
export const y100 = new Vector3(255, 247, 214);
export const y150 = new Vector3(255, 239, 174);
export const y300 = new Vector3(255, 222, 92);
export const y250 = new Vector3(255, 209, 56);
export const y600 = new Vector3(179, 134, 0);
export const y700 = new Vector3(148, 111, 0);
export const y800 = new Vector3(127, 95, 1);

export const textDefaultColor = new Vector3(23, 43, 77);
export const textDisabled = new Vector3(179, 185, 196);
export const textSubtle = new Vector3(68, 84, 111);
export const textSubtlest = new Vector3(98, 111, 134);
export const textAccentBlue = new Vector3(0, 85, 204);
export const textAccentLime = new Vector3(76, 107, 31);
export const textAccentRed = new Vector3(174, 42, 25);
export const textAccentGreen = new Vector3(33, 110, 78);
export const textAccentYellow = new Vector3(127, 95, 1);
export const textAccentPurple = new Vector3(94, 77, 178);
export const textAccentTeal = new Vector3(32, 107, 116);
export const textAccentOrange = new Vector3(151, 79, 12);
export const textAccentMagenta = new Vector3(148, 61, 115);

export const iconDefaultColor = n800;
export const iconSubtle = new Vector3(98, 111, 134);
export const iconDisabled = new Vector3(179, 185, 196);
export const iconAccentGray = new Vector3(117, 129, 149);
export const iconAccentBlue = new Vector3(29, 122, 252);
export const iconAccentLime = new Vector3(106, 154, 35);
export const iconAccentRed = new Vector3(227, 73, 53);
export const iconAccentGreen = new Vector3(34, 160, 107);
export const iconAccentYellow = new Vector3(179, 134, 0);
export const iconAccentPurple = new Vector3(130, 112, 219);
export const iconAccentTeal = new Vector3(29, 154, 170);
export const iconAccentOrange = new Vector3(217, 112, 8);
export const iconAccentMagenta = new Vector3(205, 81, 157);

export const chartGrayBoldestHovered = new Vector3(44, 62, 93);

export const background = white;
export const backgroundDark = new Vector3(29, 33, 37);
export const neutralLight = new Vector3(255, 255, 255);
export const backgroundDisabled = new Vector3(247, 248, 249);
export const backgroundInput = n0;
export const backgroundInputHovered = n100;
export const backgroundAccentGray = n300;
export const backgroundAccentBlue = new Vector3(204, 224, 255);
export const backgroundAccentLime = new Vector3(211, 241, 167);
export const backgroundAccentBlueSubtlest = new Vector3(233, 242, 255);
export const backgroundAccentRed = new Vector3(255, 210, 204);
export const backgroundAccentGreen = new Vector3(199, 248, 227);
export const backgroundAccentYellow = new Vector3(255, 239, 174);
export const backgroundAccentPurple = new Vector3(223, 216, 253);
export const backgroundAccentTeal = new Vector3(200, 244, 249);
export const backgroundAccentOrange = new Vector3(255, 222, 184);
export const backgroundAccentMagenta = new Vector3(253, 208, 236);

// color/background/accent/<color>/subtlest/hovered colors
// used as fallbacks for the token
export const backgroundAccentBlueSubtlestHovered = new Vector3(204, 224, 255);
export const backgroundAccentLimeSubtlestHovered = new Vector3(211, 241, 167);
export const backgroundAccentRedSubtlestHovered = new Vector3(255, 213, 210);
export const backgroundAccentYellowSubtlestHovered = new Vector3(248, 230, 160);
export const backgroundAccentPurpleSubtlestHovered = new Vector3(223, 216, 253);
export const backgroundAccentGreenSubtlestHovered = new Vector3(186, 243, 219);
export const backgroundAccentTealSubtlestHovered = new Vector3(198, 237, 251);
export const backgroundAccentOrangeSubtlestHovered = new Vector3(254, 222, 200);
export const backgroundAccentMagentaSubtlestHovered = new Vector3(253, 208, 236);

export const sectionTextGrey = n800;
export const sectionTextWhite = white;

export const gridlinesDark = new Vector3(45, 53, 61);
// @todo: use tokenised values in: https://product-fabric.atlassian.net/browse/CNS-15783
export const skeletonDefault = new Vector4(9, 30, 66, 0.06 * 255);
export const skeletonLightest = new Vector4(241, 242, 244, 255);
export const skeletonDarkDefault = new Vector4(75, 77, 81, 255);
export const skeletonDarkLightest = new Vector4(161, 189, 217, 0.08 * 255);

export const skeletonShimmerDark = new Vector4(105, 105, 105, 240); // Gray
export const skeletonShimmerLight = new Vector4(255, 255, 255, 240); // White

export const borderDefaultColor = new Vector3(220, 223, 228);
export const borderDisabled = new Vector3(241, 242, 244);
export const borderFocused = new Vector3(56, 139, 255);

export const shadowOverflow = new Vector3(9, 30, 66);

export const ghostConnectorPreview = new Vector3(115, 150, 220);

// Hardcoded match colors - kept as fallbacks for COLOR_ID_TO_VEC lookups
export const matchColor = Vector3.fromHexColor('#FDD0EC');
export const matchBorderColor = Vector3.fromHexColor('#E774BB');
export const matchActiveColor = Vector3.fromHexColor('#F797D2');
export const matchActiveBorderColor = matchBorderColor;

// Colors used in WDF https://hello.atlassian.net/wiki/spaces/CAN/pages/3797168860/WDF+Colours
export const darkPaletteDarkColorMapCanvasTokens = {
  'color.text': 'palette.dark.gray.300',
  'color.text.accent.blue': 'palette.dark.blue.300',
  'color.text.accent.red': 'palette.dark.red.300',
  'color.text.accent.green': 'palette.dark.green.300',
  'color.text.accent.yellow': 'palette.dark.yellow.300',
  'color.text.accent.purple': 'palette.dark.purple.300',
  'color.text.accent.teal': 'palette.dark.teal.300',
  'color.text.accent.orange': 'palette.dark.orange.300',
  'color.text.accent.magenta': 'palette.dark.magenta.300',
  'color.text.accent.lime': 'palette.dark.lime.300',
} as const;

export const darkPaletteMediumColorMapCanvasTokens = {
  'color.icon.accent.gray': 'palette.dark.gray.200',
  'color.icon.accent.blue': 'palette.dark.blue.200',
  'color.icon.accent.red': 'palette.dark.red.200',
  'color.icon.accent.green': 'palette.dark.green.200',
  'color.border.accent.yellow': 'palette.dark.yellow.200',
  'color.icon.accent.purple': 'palette.dark.purple.200',
  'color.icon.accent.teal': 'palette.dark.teal.200',
  'color.icon.accent.orange': 'palette.dark.orange.200',
  'color.icon.accent.magenta': 'palette.dark.magenta.200',
  'color.icon.accent.lime': 'palette.dark.lime.200',
} as const;

export const darkPaletteLightColorMapCanvasTokens = {
  'elevation.surface': 'palette.dark.gray.100',
  'color.background.accent.blue.subtler': 'palette.dark.blue.100',
  'color.background.accent.red.subtler': 'palette.dark.red.100',
  'color.background.accent.green.subtlest.hovered': 'palette.dark.green.100',
  'color.background.accent.yellow.subtler': 'palette.dark.yellow.100',
  'color.background.accent.purple.subtler': 'palette.dark.purple.100',
  'color.background.accent.teal.subtlest.hovered': 'palette.dark.teal.100',
  'color.background.accent.orange.subtler': 'palette.dark.orange.100',
  'color.background.accent.magenta.subtler': 'palette.dark.magenta.100',
  'color.background.accent.lime.subtlest.hovered': 'palette.dark.lime.100',
} as const;

export type DarkPaletteCanvasTokens =
  | (typeof darkPaletteLightColorMapCanvasTokens)[keyof typeof darkPaletteLightColorMapCanvasTokens]
  | (typeof darkPaletteMediumColorMapCanvasTokens)[keyof typeof darkPaletteMediumColorMapCanvasTokens]
  | (typeof darkPaletteDarkColorMapCanvasTokens)[keyof typeof darkPaletteDarkColorMapCanvasTokens];

/**
 * @deprecated Paths/connectors/shape borders that used to run the medium palette now run the dark palette
 */
export const mediumPaletteDarkColorMapCanvasTokens = {
  'color.border.accent.gray': 'palette.medium.gray.300',
  'color.border.accent.blue': 'palette.medium.blue.300',
  'color.border.accent.red': 'palette.medium.red.300',
  'color.border.accent.green': 'palette.medium.green.300',
  'color.border.accent.yellow': 'palette.medium.yellow.300',
  'color.border.accent.purple': 'palette.medium.purple.300',
  'color.border.accent.teal': 'palette.medium.teal.300',
  'color.border.accent.orange': 'palette.medium.orange.300',
  'color.border.accent.magenta': 'palette.medium.magenta.300',
  'color.border.accent.lime': 'palette.medium.lime.300',
} as const;

/**
 * @deprecated Paths/connectors/shape borders that used to run the medium palette now run the dark palette
 */
export const mediumPaletteMediumColorMapCanvasTokens = {
  'color.background.accent.gray.subtler.hovered': 'palette.medium.gray.200',
  'color.background.accent.blue.subtlest.pressed': 'palette.medium.blue.200',
  'color.background.accent.red.subtlest.pressed': 'palette.medium.red.200',
  'color.background.accent.green.subtlest.pressed': 'palette.medium.green.200',
  'color.background.accent.yellow.subtlest.pressed': 'palette.medium.yellow.200',
  'color.background.accent.purple.subtlest.pressed': 'palette.medium.purple.200',
  'color.background.accent.teal.subtlest.pressed': 'palette.medium.teal.200',
  'color.background.accent.orange.subtlest.pressed': 'palette.medium.orange.200',
  'color.background.accent.magenta.subtlest.pressed': 'palette.medium.magenta.200',
  'color.background.accent.lime.subtlest.pressed': 'palette.medium.lime.200',
} as const;

/**
 * @deprecated Paths/connectors/shape borders that used to run the medium palette now run the dark palette
 */
export const mediumPaletteLightColorMapCanvasTokens = {
  'color.background.accent.gray.subtlest': 'palette.medium.gray.100',
  'color.background.accent.blue.subtler': 'palette.medium.blue.100',
  'color.background.accent.red.subtler': 'palette.medium.red.100',
  'color.background.accent.green.subtlest.hovered': 'palette.medium.green.100',
  'color.background.accent.yellow.subtler': 'palette.medium.yellow.100',
  'color.background.accent.purple.subtler': 'palette.medium.purple.100',
  'color.background.accent.teal.subtlest.hovered': 'palette.medium.teal.100',
  'color.background.accent.orange.subtler': 'palette.medium.orange.100',
  'color.background.accent.magenta.subtler': 'palette.medium.magenta.100',
  'color.background.accent.lime.subtlest.hovered': 'palette.medium.lime.100',
} as const;

/**
 * @deprecated Paths/connectors/shape borders that used to run the medium palette now run the dark palette
 */
export type MediumPaletteCanvasTokens =
  | (typeof mediumPaletteLightColorMapCanvasTokens)[keyof typeof mediumPaletteLightColorMapCanvasTokens]
  | (typeof mediumPaletteMediumColorMapCanvasTokens)[keyof typeof mediumPaletteMediumColorMapCanvasTokens]
  | (typeof mediumPaletteDarkColorMapCanvasTokens)[keyof typeof mediumPaletteDarkColorMapCanvasTokens];

export const lightPaletteDarkColorMapCanvasTokens = {
  'color.background.accent.gray.subtler.hovered': 'palette.light.gray.300',
  'color.background.accent.blue.subtlest.pressed': 'palette.light.blue.300',
  'color.background.accent.red.subtlest.pressed': 'palette.light.red.300',
  'color.background.accent.green.subtlest.pressed': 'palette.light.green.300',
  'color.background.accent.yellow.subtlest.pressed': 'palette.light.yellow.300',
  'color.background.accent.purple.subtlest.pressed': 'palette.light.purple.300',
  'color.background.accent.teal.subtlest.pressed': 'palette.light.teal.300',
  'color.background.accent.orange.subtlest.pressed': 'palette.light.orange.300',
  'color.background.accent.magenta.subtlest.pressed': 'palette.light.magenta.300',
  'color.background.accent.lime.subtlest.pressed': 'palette.light.lime.300',
} as const;

export const lightPaletteMediumColorMapCanvasTokens = {
  'color.background.accent.gray.subtlest': 'palette.light.gray.200',
  'color.background.accent.blue.subtler': 'palette.light.blue.200',
  'color.background.accent.red.subtler': 'palette.light.red.200',
  'color.background.accent.green.subtlest.hovered': 'palette.light.green.200',
  'color.background.accent.yellow.subtler': 'palette.light.yellow.200',
  'color.background.accent.purple.subtler': 'palette.light.purple.200',
  'color.background.accent.teal.subtlest.hovered': 'palette.light.teal.200',
  'color.background.accent.orange.subtler': 'palette.light.orange.200',
  'color.background.accent.magenta.subtler': 'palette.light.magenta.200',
  'color.background.accent.lime.subtlest.hovered': 'palette.light.lime.200',
} as const;

export const lightPaletteLightColorMapCanvasTokens = {
  'color.background.input': 'palette.light.gray.100',
  'color.background.accent.blue.subtlest': 'palette.light.blue.100',
  'color.background.accent.red.subtlest': 'palette.light.red.100',
  'color.background.accent.green.subtlest': 'palette.light.green.100',
  'color.background.accent.yellow.subtlest': 'palette.light.yellow.100',
  'color.background.accent.purple.subtlest': 'palette.light.purple.100',
  'color.background.accent.teal.subtlest': 'palette.light.teal.100',
  'color.background.accent.orange.subtlest': 'palette.light.orange.100',
  'color.background.accent.magenta.subtlest': 'palette.light.magenta.100',
  'color.background.accent.lime.subtlest': 'palette.light.lime.100',
} as const;

export type LightPaletteCanvasTokens =
  | (typeof lightPaletteLightColorMapCanvasTokens)[keyof typeof lightPaletteLightColorMapCanvasTokens]
  | (typeof lightPaletteMediumColorMapCanvasTokens)[keyof typeof lightPaletteMediumColorMapCanvasTokens]
  | (typeof lightPaletteDarkColorMapCanvasTokens)[keyof typeof lightPaletteDarkColorMapCanvasTokens];

export type CanvasPaletteToken =
  | LightPaletteCanvasTokens
  | MediumPaletteCanvasTokens
  | DarkPaletteCanvasTokens;

export enum ColorPaletteType {
  LIGHT = 'light',
  MEDIUM = 'medium',
  DARK = 'dark',
}

export const textMention = textSubtle;
export const textSelfMention = white;

export const backgroundMention = skeletonDefault;
export const backgroundMentionHover = new Vector4(9, 30, 66, 0.14 * 255);
export const backgroundSelfMention = new Vector4(12, 102, 228, 255);
export const backgroundSelfMentionHover = new Vector4(0, 85, 204, 1 * 255);
